module.exports = __webpack_public_path__ + "assets/media/day20.ab474090.mp3";